<template>
  <div
    class="conversationMainRow"
    @click="setActiveConversation()"
    :class="{
      isActive: conversation.ConversationID === $store.state.conversation.activeConversation.ConversationID
    }"
    v-if="conversation"
  >
    <!-- {{conversation.ConversationID}} -->
    <div class="conversationRow" v-if="conversation.isGroupConversation === true || conversation.isChannelConversation === true" @contextmenu.prevent="emptyContextMenu">
      <img class="contactPhoto" :src="photo" v-if="conversation && conversation.PhotoURL" />
      <img class="contactPhoto" src="@/assets/images/groupdefault.png" v-else />

      <div class="rightItems" v-if="$store.state.display.leftColumn.isExpanded">
        <div class="upperRow">
          <div class="contactNameDiv">
            {{ conversation.isChannelConversation ? conversation.ChannelName : conversation.GroupName }}
          </div>
          <div class="time" v-if="lastMessage">
            <span v-if="!isDateShow">{{ lastMessage.UpdateDate | moment('HH:mm') }}</span>
            <span v-else>{{ lastMessage.UpdateDate | moment('DD.MM.YYYY') }}</span>
          </div>
        </div>
        <div class="lowerRow">
          <div class="lastMessageDiv" :class="{ hasUnread: conversation.UnreadMessageCount > 0 }" v-if="lastMessage && !showWritingParticipant">
            <span v-if="lastMessage.MessageType === 0"> {{ getUserNameDisplay(lastMessage.From) }} : </span>
            <span v-html="getLastMessageBody" />
          </div>
          <!-- <div v-else>
            {{ lastMessage }}--
          </div> -->
          <div class="userWriting" v-else-if="showWritingParticipant">{{ writingParticipant }} yazıyor...</div>
          <div class="lastMessageDiv" :class="{ hasUnread: conversation.UnreadMessageCount > 0 }" v-else>
            <span v-html="getLastMessageBody" />
          </div>
          <svg v-if="conversation.isPinned == true" id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" width="19" height="19"><path fill="#263238" fill-opacity=".25" d="M9.5 18.419C4.574 18.419.581 14.426.581 9.5S4.574.581 9.5.581s8.919 3.993 8.919 8.919-3.993 8.919-8.919 8.919zm2.121-5.708l-.082-2.99 1.647-1.963a1.583 1.583 0 0 0-.188-2.232l-.32-.269a1.58 1.58 0 0 0-2.231.203L8.803 7.42l-2.964.439a.282.282 0 0 0-.14.496l5.458 4.58c.186.157.47.019.464-.224zM5.62 13.994a.504.504 0 0 0 .688-.038l2.204-2.307-1.085-.91-1.889 2.571a.504.504 0 0 0 .082.684z" /></svg>
          <div class="unreadMessagesCount" v-if="conversation.UnreadMessageCount > 0">
            {{ conversation.UnreadMessageCount }}
          </div>
        </div>
      </div>
    </div>
    <div class="conversationRow" v-else @contextmenu.prevent="emptyContextMenu">
      <img class="contactPhoto" :src="contactPhoto" v-if="conversation && conversation.Contact" />
      <img class="contactPhoto" src="@/assets/images/nophoto.png" v-else-if="conversation.Contact && !conversation.Contact.PhotoURL" />
      <div class="rightItems" v-if="$store.state.display.leftColumn.isExpanded && conversation.Contact">
        <div class="upperRow">
          <div class="contactNameDiv">
            {{ conversation.Contact.VisibleName }}
          </div>
          <div class="time" v-if="lastMessage">
            <span v-if="!isDateShow">{{ lastMessage.UpdateDate | moment('HH:mm') }}</span>
            <span v-else>{{ lastMessage.UpdateDate | moment('DD.MM.YYYY') }}</span>
          </div>
        </div>
        <div class="lowerRow">
          <div class="lastMessageDiv" :class="{ hasUnread: conversation.UnreadMessageCount > 0 }" v-if="lastMessage !== null && conversation.isBuddyWriting === false">
            <span v-html="getLastMessageBody" />
          </div>
          <div class="userWriting" v-if="conversation.isBuddyWriting === true">
            Yazıyor...
          </div>
          <svg v-if="conversation.isPinned == true" id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" width="19" height="19"><path fill="#263238" fill-opacity=".25" d="M9.5 18.419C4.574 18.419.581 14.426.581 9.5S4.574.581 9.5.581s8.919 3.993 8.919 8.919-3.993 8.919-8.919 8.919zm2.121-5.708l-.082-2.99 1.647-1.963a1.583 1.583 0 0 0-.188-2.232l-.32-.269a1.58 1.58 0 0 0-2.231.203L8.803 7.42l-2.964.439a.282.282 0 0 0-.14.496l5.458 4.58c.186.157.47.019.464-.224zM5.62 13.994a.504.504 0 0 0 .688-.038l2.204-2.307-1.085-.91-1.889 2.571a.504.504 0 0 0 .082.684z" /></svg>
          <div class="unreadMessagesCount" v-if="conversation.UnreadMessageCount > 0">
            {{ conversation.UnreadMessageCount }}
          </div>
        </div>
      </div>
    </div>

    <vue-context ref="contextMenu">
      <ul>
        <li @click="deleteConversation">
          Sohbeti Sil
        </li>
      </ul>
    </vue-context>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'
import EventBus from '@/eventbus.js'
import { VueContext } from 'vue-context'
var moment = require('moment')

export default {
  props: {
    conversation: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },

  mixins: [messageMixin],

  components: {
    VueContext
  },
  asyncComputed: {
    contactPhoto() {
      if (this.conversation.Contact === undefined || this.conversation.Contact.PhotoURL === undefined) {
        return ''
      }
      if (this.$config === undefined) {
        return ''
      }
      if (this.conversation.Contact.PhotoURL.includes('http') || this.conversation.Contact.PhotoURL.includes('nophoto.png')) {
        return this.makeBlob(this.conversation.Contact.PhotoURL, this.conversation.Contact.PhotoURL)
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key
          .split('')
          .reverse()
          .join('')
        let encryptedBody = this.ewk(this.conversation.Contact.PhotoURL, key, iv)
        return this.makeBlob(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + this.conversation.Contact.PhotoURL + '&s=' + encodeURIComponent(encryptedBody), this.conversation.Contact.PhotoURL)
      }
    },
    photo() {
      if (this.conversation.PhotoURL === undefined || this.conversation.PhotoURL === null) {
        return ''
      }
      if (this.$config === undefined) {
        return ''
      }
      if (this.conversation.PhotoURL.includes('http')) {
        return this.makeBlob(this.conversation.PhotoURL, this.conversation.PhotoURL)
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key
          .split('')
          .reverse()
          .join('')
        let encryptedBody = this.ewk(this.conversation.PhotoURL, key, iv)
        return this.makeBlob(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + this.conversation.PhotoURL + '&s=' + encodeURIComponent(encryptedBody), this.conversation.PhotoURL)
      }
    }
  },
  computed: {
    isDateShow() {
      let message = this.lastMessage
      let messageDate = message && (message.UpdateDate || message.CreateDate)
      if (!messageDate) {
        return false
      }
      var hours = moment().diff(messageDate, 'hours')
      var days = moment().diff(messageDate, 'days')
      var years = moment().diff(messageDate, 'years')
      var months = moment().diff(messageDate, 'months')
      if (years >= 1 || days >= 1 || months >= 1 || hours >= 24) {
        return true
      } else {
        return false
      }
    },
    lastMessage() {
      let lastMessageOfConversation = this.conversation.LastMessage
      if (
        this.conversation.isChannelConversation &&
        (!lastMessageOfConversation || Object.keys(lastMessageOfConversation).length === 0)
      ) {
        lastMessageOfConversation = this.$store.getters.lastMessageOfConversation(this.conversation)
        if (lastMessageOfConversation) {
          lastMessageOfConversation = { ...lastMessageOfConversation }
        }
      }
      if (lastMessageOfConversation && this.$store.state.ien) {
        if (lastMessageOfConversation.MessageType !== 7 && lastMessageOfConversation.MessageType !== 99 && lastMessageOfConversation.Body && lastMessageOfConversation.Body !== '') {
          this.dm(lastMessageOfConversation)
        }
      }
      return lastMessageOfConversation
    },
    getLastMessageBody() {
      return this.getMessageBody(this.lastMessage)
    },
    writingParticipant() {
      return this.conversation.writingParticipant
    },
    showWritingParticipant() {
      return !this.conversation.isChannelConversation && this.writingParticipant
    }
  },

  methods: {
    emptyContextMenu() {},

    deleteConversation() {
      // let conversationToDelete = this.conversation
    },

    setActiveConversation() {
      const vm = this
      this.$store.state.message.currentMessageText = ''
      this.$store.state.display.rightSideColumn.isExpanded = false

      let activeConversation = this.conversation
      if (this.conversation.isChannelConversation || this.conversation.ChannelID) {
        activeConversation = this.$store.state.channel.channels.find(x => x.ChannelID === this.conversation.ChannelID || x.ChannelID === this.conversation.ConversationID) || this.conversation
      } else if (this.conversation.isGroupConversation || this.conversation.GroupID) {
        activeConversation = this.$store.state.group.groups.find(x => x.GroupID === this.conversation.GroupID || x.GroupID === this.conversation.ConversationID) || this.conversation
      } else {
        activeConversation = this.$store.state.conversation.conversations.find(x => x.ConversationID === this.conversation.ConversationID) || this.conversation
      }

      EventBus.$emit('scrollToBottom')
      this.$store.commit('resetConversationPage')
      this.$store.commit('setMessageBalloonsTransitionName', 'none')
      this.$store.commit('setActiveConversation', activeConversation)
      this.$store.state.conversation.activeConversationID = activeConversation.ConversationID
      EventBus.$emit('focusInputBar')
      setTimeout(function() {
        vm.$store.commit('setMessageBalloonsTransitionName', 'flip-list')
        vm.setReadStatusOfActiveConversationMessages()
      }, 100)
    },

    getMessageBody(message) {
      if (message && message.MessageType !== undefined) {
        // var msg = 'boş' + message.MessageType
        var msg = ''

        if (message.DeleteStatus === 12) {
          msg = this.getDeletedMessageInfo(message)
        } else {
          switch (parseInt(message.MessageType)) {
            case 0:
              msg = message.Body
              break
            case 1:
              msg = this.getImageMessageInfo(message)
              break
            case 2:
              msg = this.getVideoMessageInfo(message)
              break
            case 3:
              msg = this.getLinkMessageInfo(message)
              break
            case 4:
              msg = this.interpretedLocationMessage(message)
              break
            case 5:
              msg = this.getAudioMessageInfo(message)
              break
            case 6:
              msg = this.interpretedContactMessage(message)
              break
            case 7:
              msg = this.interpretedInfoMessage(message)
              break
            case 8:
              msg = this.getAudioMessageInfo(message)
              break
            case 20:
              msg = this.getUnansweredCallMessageInfo(message)
              break
            case 100:
              msg = this.getDocumentMessageInfo(message)
              break
            default:
              break
          }
        }
        return msg
      } else {
        return ''
      }
    },

    getDeletedMessageInfo(message) {
      if (message.From === this.$store.state.session.user.UserID) {
        return 'Bu mesajı sildiniz.'
      } else {
        return 'Bu mesaj silindi.'
      }
    },

    getImageMessageInfo(message) {
      let photoImg = '<img src="/images/content-types/content_photo.png" class="messageTypeImage"/>'
      if (message.From === this.currentUser.UserID) {
        return 'Siz: ' + photoImg + ' Fotoğraf'
      }
      return this.getUserNameDisplay(message.From) + ': ' + photoImg + ' Fotoğraf'
    },

    getVideoMessageInfo(message) {
      let photoImg = '<img src="/images/content-types/content_video.png" class="messageTypeImage"/>'
      if (message.From === this.currentUser.UserID) {
        return 'Siz: ' + photoImg + ' Video'
      }
      return this.getUserNameDisplay(message.From) + ': ' + photoImg + ' Video'
    },

    getLinkMessageInfo(message) {
      let photoImg = '<img src="/images/content-types/content_link.png" class="messageTypeImage"/>'
      if (message.From === this.currentUser.UserID) {
        return 'Siz: ' + photoImg + ' Bağlantı'
      }
      return this.getUserNameDisplay(message.From) + ': ' + photoImg + ' Bağlantı'
    },

    interpretedLocationMessage(message) {
      let photoImg = '<img src="/images/content-types/content_location.png" class="messageTypeImage"/>'
      if (message.From === this.currentUser.UserID) {
        return 'Siz: ' + photoImg + ' Konum'
      }
      return this.getUserNameDisplay(message.From) + ': ' + photoImg + ' Konum'
    },

    getVoiceMessageInfo(message) {
      let photoImg = '<img src="/images/content-types/content_voice.png" class="messageTypeImage"/>'
      if (message.From === this.currentUser.UserID) {
        return 'Siz: ' + photoImg + ' Ses kaydı'
      }
      return this.getUserNameDisplay(message.From) + ': ' + photoImg + ' Ses kaydı'
    },

    interpretedContactMessage(message) {
      let photoImg = '<img src="/images/content-types/content_contact.png" class="messageTypeImage"/>'
      if (message.From === this.currentUser.UserID) {
        return 'Siz: ' + photoImg + ' Kişi'
      }
      return this.getUserNameDisplay(message.From) + ': ' + photoImg + ' Kişi'
    },

    getAudioMessageInfo(message) {
      let photoImg = '<img src="/images/content-types/content_audio.png" class="messageTypeImage"/>'
      if (message.From === this.currentUser.UserID) {
        return 'Siz: ' + photoImg + ' Ses dosyası'
      }
      return this.getUserNameDisplay(message.From) + ': ' + photoImg + ' Ses dosyası'
    },

    getUnansweredCallMessageInfo(message) {
      let photoImg = '<span style="color:#df3333;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" width="20" height="17"><path fill="currentColor" d="M18.2 12.1c-1.5-1.8-5-2.7-8.2-2.7s-6.7 1-8.2 2.7c-.7.8-.3 2.3.2 2.8.2.2.3.3.5.3 1.4 0 3.6-.7 3.6-.7.5-.2.8-.5.8-1v-1.3c.7-1.2 5.4-1.2 6.4-.1l.1.1v1.3c0 .2.1.4.2.6.1.2.3.3.5.4 0 0 2.2.7 3.6.7.2 0 1.4-2 .5-3.1zM5.4 3.2l4.7 4.6 5.8-5.7-.9-.8L10.1 6 6.4 2.3h2.5V1H4.1v4.8h1.3V3.2z"></path></svg></span>'
      if (message.From === this.currentUser.UserID) {
        return photoImg + ' Cevapsız Arama'
      }
      return photoImg + ' Cevapsız Arama'
    },

    getDocumentMessageInfo(message) {
      let photoImg = '<img src="/images/content-types/content_document.png" class="messageTypeImage"/>'
      if (message.From === this.currentUser.UserID) {
        return 'Siz: ' + photoImg + ' Dosya'
      }
      return this.getUserNameDisplay(message.From) + ': ' + photoImg + ' Dosya'
    }
  }
}
</script>

<style scoped>
.conversationMainRow {
  background-color: white;
  margin-bottom: 1px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}

.conversationMainRow:hover {
  background-color: #f4f5f5;
}

.conversationRow {
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-grow: 1;
}

.conversationRow:hover {
  background-color: #f4f5f5;
}

.contactPhoto {
  width: 50px;
  min-width: 50px;
  height: 50px;
  border-radius: 25px;
  object-fit: cover;
  border: 1px solid white;
}

.upperRow {
  padding-left: 10px;
  height: 50%;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  width: 100%;
}

.lowerRow {
  display: flex;
}

.lastMessageDiv,
.userWriting {
  padding-left: 10px;
  height: 50%;
  font-weight: 300;
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: calc(310px);
  flex-grow: 1;
  display: block;
}

.lastMessageDiv {
  color: #6d6d6d;
}

.unreadMessagesCount {
  background-color: #f22627;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: white;
  text-align: center;
  flex-shrink: 0;
  flex-grow: 0;
}

.userWriting {
  font-style: italic;

  color: rgb(2, 158, 197);
}

.isActive {
  background-color: #eaeceb;
}

.rightItems {
  flex-grow: 1;
}

.contactNameDiv {
  flex-grow: 1;
}

.time {
  flex-grow: 0;
  flex-shrink: 0;
  padding-right: 5px;
  font-weight: 400;
  font-size: 12px;
  color: rgb(146, 146, 146);
}

.hasUnread {
  font-weight: 700;
  max-width: calc(310px);
}
</style>

<style>
.messageTypeImage {
  width: 20px;
  height: 10px;
  object-fit: contain;
}
</style>
